import script from "./FilePermitionSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePermitionSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FilePermitionSelect.vue?vue&type=style&index=0&id=688a6674&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688a6674"]])

export default __exports__